import React, { useEffect, useState } from "react";
import { Button } from "../../../../../../../components/button.jsx";
import { useResource } from "../../../../../../../hooks/useResource.js";

export function StepAccountList({ setBank, bank }) {
  let [connectedBanks, setConnectedBanks] = useState([]);
  let bankService = useResource("bank_accounts");

  useEffect(() => {
    bankService.list().then((res) => setConnectedBanks(res));
  }, []);

  let deleteAccount = (id) => {
    return bankService.delete(id).then(() => {
      setConnectedBanks(connectedBanks.filter((bank) => bank.id !== id));
    });
  };

  return (
    <div className={"flex flex-col gap-3"}>
      <h1 className={"font-bold"}>Select your account</h1>

      <p>Please select the bank account you'll use to import your data</p>

      {connectedBanks.map(({ logo, id, name, iban, hasIssue }) => (
        <div
          className={
            "flex flex-col md:flex-row gap-3 md:items-center p-3 rounded " +
            (hasIssue
              ? "bg-orange-50"
              : "cursor-pointer bg-blue-50 hover:bg-blue-100")
          }
          key={id}
          onClick={() => {
            setBank({
              ...bank,
              step: "sync",
              account: { id, name, logo, iban },
            });
          }}
        >
          <div style={{ height: 40 }}>
            <img src={logo} style={{ maxWidth: "100%", maxHeight: "100%" }} />
          </div>
          <div className={"flex-grow"}>
            {name} {hasIssue && <span className={"fa fa-warning"} />}
          </div>
          <div>{iban}</div>
          <div>
            <Button
              variant={"alert"}
              onClick={(e) => {
                e.stopPropagation();
                return deleteAccount(id);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ))}

      {connectedBanks.find(({ hasIssue }) => hasIssue) && (
        <div className={"bg bg-red-200 p-3 rounded"}>
          We cannot fetch the data of all your bank accounts. Please remove or
          reconnect them.
        </div>
      )}

      <Button
        onClick={() => {
          return setBank({ ...bank, step: "add" });
        }}
      >
        (re)Connect with my bank
      </Button>
    </div>
  );
}
